import { render, staticRenderFns } from "./TabelaExemploUpload.vue?vue&type=template&id=4ce78f93&scoped=true"
import script from "./TabelaExemploUpload.vue?vue&type=script&lang=js"
export * from "./TabelaExemploUpload.vue?vue&type=script&lang=js"
import style0 from "./TabelaExemploUpload.vue?vue&type=style&index=0&id=4ce78f93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce78f93",
  null
  
)

export default component.exports